export var delayRun = function (fn, delay) {
    var timeoutId = window.setTimeout(fn, delay);
    return function () {
        window.clearTimeout(timeoutId);
    };
};
